<template>
    <form class="row g-3" ref="form">
        <div class="col-6">
            <label for="name" class="form-label fw-bold">{{ $t("guestbook.name") }}</label>
            <input type="text" class="form-control" id="name" v-model="localGuestbook.name" required>
        </div>
        <div class="col-6">
            <label for="company" class="form-label fw-bold">{{ $t("guestbook.company") }}</label>
            <input type="text" class="form-control" id="company" v-model="localGuestbook.company" required>
        </div>
        <div class="col-6">
            <label for="cardNumber" class="form-label fw-bold">{{ $t("guestbook.cardNumber") }}</label>
            <input type="text" class="form-control" id="cardNumber" v-model="localGuestbook.cardNumber" required>
        </div>
        <div class="col-12">
            <label for="cardType" class="form-label fw-bold">{{ $t("guestbook.cardType") }}</label>
            <div class="d-flex flex-wrap">
                <div
                    v-for="type in documentTypes"
                    :key="type.value"
                    class="status-block p-2 me-3 mb-3 mb-md-0 rounded text-center"
                    :class="{ 'selected': localGuestbook.cardType === type.value}"
                    @click="localGuestbook.cardType = type.value"
                >
                <div class="fs-6 fw-bold">{{ $t("documentType." + type.value) }}</div>
                <input
                    type="radio"
                    class="d-none"
                    :checked="localGuestbook.cardType === type.value"
                >
                </div>
            </div>
        </div>
        <div class="col-6">
            <label for="expectedFrom" class="form-label fw-bold">{{ $t("guestbook.expectedFrom") }}</label>
            <input type="datetime-local" class="form-control" id="expectedFrom" v-model="localGuestbook.expectedFrom" >
        </div>
        <div class="col-6">
            <label for="expectedTo" class="form-label fw-bold">{{ $t("guestbook.expectedTo") }}</label>
            <input
                type="datetime-local"
                class="form-control"
                id="expectedTo"
                v-model="localGuestbook.expectedTo"
                :min="localGuestbook.expectedFrom"
                :class="{ 'is-invalid': isInvalidDateRange }"
            >
        </div>
        <div class="col-12">
            <label for="status" class="form-label fw-bold">{{ $t("status.status") }}</label>
            <div class="d-flex flex-wrap">
                <div
                    v-for="status in statuses"
                    :key="status.id"
                    class="status-block p-2 me-3 mb-3 mb-md-0 rounded text-center"
                    :class="{ 'selected': localGuestbook.status === status.id}"
                    @click="localGuestbook.status = status.id"
                >
                    <icon :icon="status.icon" class="status_icon" />
                    <div class="fs-6 fw-bold">{{ $t("status.guestbook." + status.name) }}</div>
                    <input
                        type="radio"
                        class="d-none"
                        :checked="localGuestbook.status === status.id"
                    >
                </div>
            </div>
        </div>
    </form>
</template>

<script>
    import Icon from '@/components/Icon.vue'
    import { formatDatetimeLocal } from '@/utils/date';

    export default {
        components: {
            Icon,
        },
        emits: ["submit"],
        props: {
            guestbook: {
                type: Object,
                default: () => ({})
            }
        },
        data() {
            return {
                localGuestbook: {...this.guestbook},
                statuses: [],
                documentTypes: [],
            }
        },
        created() {
            this.getStatuses();
            this.getDocumentTypes();
        },
        methods: {
            validateData() {
                if (this.$refs.form.checkValidity() === false){
                    this.$refs.form.reportValidity();
                    return false;
                }
                return true;
            },
            submitForm() {
                if (!this.validateData()) return;
                    this.$emit("submit", this.localGuestbook)
            },
            getStatuses() {
                this.$store.getters.api.get(`/${this.$route.params.slug}/statuses?model=guestbook`)
                .then(response => {
                    this.statuses = response.data;
                })
                .catch(error => {
                    console.error("Error loading statuses", error);
                });
            },
            getDocumentTypes() {
                this.$store.getters.api.get("/document-types")
                .then(response => {
                    this.documentTypes = response.data;
                })
                .catch(error => {
                    console.error("Error loading document types", error);
                });
            },
        },
        computed: {
            isInvalidDateRange() {
                const from = new Date(this.localGuestbook.expectedFrom);
                const to = new Date(this.localGuestbook.expectedTo);
                return this.localGuestbook.expectedFrom && this.localGuestbook.expectedTo && to <= from;
            }
        },
        watch: {
            guestbook: {
                handler(newVal) {
                    this.localGuestbook = {
                        name: newVal.guest_name || "",
                        company: newVal.company || "",
                        cardNumber: newVal.personal_card_number || "",
                        cardType: newVal.personal_card_type || "",
                        expectedFrom: formatDatetimeLocal(newVal.expected_from) || "",
                        expectedTo: formatDatetimeLocal(newVal.expected_to) || "",
                        status: newVal.status || "",
                    };
                },
                immediate: true,
            }
        }
    }
</script>

<style scoped>
    .status_icon {
        width: 40px;
        height: 40px;
    }
</style>